import { render } from "./AdminUserData.vue?vue&type=template&id=0cdc892c&scoped=true"
import script from "./AdminUserData.vue?vue&type=script&lang=js"
export * from "./AdminUserData.vue?vue&type=script&lang=js"

import "./AdminUserData.vue?vue&type=style&index=0&id=0cdc892c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdc892c"]])

export default __exports__